import useProfile from "api/UserResource/useProfile";
import UpdateProfile from "./UpdateProfile";
import { Container } from "layouts";
import PaddingX from "layouts/PaddingX";
import AccountLayout from "./AccountLayout";

const MyAccount = () => {
	const { data: profile, isLoading: isLoadingProfile } = useProfile();

	return (
		<Container>
			<div className="min-h-screen bg-gray-50">
				<div className="pt-8 pb-16">
					<PaddingX>
						<AccountLayout isLoading={isLoadingProfile} profile={profile?.data}>
							{/* Header Section */}
							<div className="mb-10">
								<div className="flex items-center gap-3 mb-3">
									<div className="w-10 h-10 bg-gray-100 rounded-xl flex items-center justify-center">
										<svg
											className="w-5 h-5 text-gray-600"
											fill="none"
											stroke="currentColor"
											viewBox="0 0 24 24"
										>
											<path
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth={2}
												d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"
											/>
										</svg>
									</div>
									<h1 className="text-2xl font-semibold ">Profile Information</h1>
								</div>
								<p className="text-gray-500 text-sm leading-relaxed ml-13">
									Manage your personal details and account information. Fields marked with (*) are
									required.
								</p>
							</div>

							{/* Profile Status Card */}
							{profile?.data && (
								<div className="mb-8 p-4 bg-white border border-gray-200 rounded-xl">
									<div className="flex items-center justify-between">
										<div className="flex items-center gap-3">
											<div className="w-3 h-3 bg-green-400 rounded-full"></div>
											<span className="text-sm font-medium text-gray-700">Profile Status</span>
										</div>
										<div className="text-sm text-gray-500">
											{profile.data.first_name && profile.data.last_name
												? "Complete"
												: "Incomplete"}
										</div>
									</div>
								</div>
							)}

							{/* Profile Form */}
							<UpdateProfile
								userId={profile?.data?.id}
								firstName={profile?.data?.first_name || ""}
								lastName={profile?.data?.last_name || ""}
								mobileNumber={profile?.data?.mobile_number || ""}
								sex={profile?.data?.sex || ""}
								dob={profile?.data?.dob || ""}
							/>
						</AccountLayout>
					</PaddingX>
				</div>
			</div>
		</Container>
	);
};

export default MyAccount;
